import { getErrorStatus, getErrorText } from '../../../common/api/errors'

const TICKET_LOCKED_TEXT = 'Этот тикет нельзя изменить'

/** Отказ смены статуса из списка завершённых: статус тикета не тот — свой текст, иначе причина бэкенда. */
export const ticketChangeErrorText = (error: unknown): string =>
  getErrorStatus(error) === 422
    ? TICKET_LOCKED_TEXT
    : getErrorText(error, TICKET_LOCKED_TEXT, { withFieldName: false })

/**
 * Отказ ручного завершения депозита: 422 — тикет в неподходящем статусе; 400 — причина бэкенда (виртуальный
 * мерчант — русским текстом), без неё «Невозможно завершить тикет».
 */
export const finishErrorText = (error: unknown): string => {
  const status = getErrorStatus(error)
  if (status === 422) {
    return 'Тикет не может быть завершен'
  }

  return getErrorText(error, status === 400 ? 'Невозможно завершить тикет' : 'Не удалось завершить тикет', {
    withFieldName: false,
  })
}
